// extracted by mini-css-extract-plugin
export var option = "_2y-0";
export var optionSelected = "_2y-1 _2y-0";
export var optionUnselected = "_2y-2 _2y-0";
export var radioInner = "_2y-5";
export var radioOuter = "_2y-3";
export var radioOuterSelected = "_2y-4 _2y-3";